module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (7).f8304e78.jpg";